module.exports = __webpack_public_path__ + "img/real-example-mob.87f97cc.webp";